module.exports = __webpack_public_path__ + "img/symbol_2.d246c11a.png";